<template>
  <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
    <div v-if="activityStatus == 0" :class="`${$style.pageWrapper}`" :style="{filter: 'grayscale(.5)'}">
      <img :class="$style.pageBack" :src="cdnLink + `/box_turntable/luckyBg1.jpeg`" />
      <div :class="$style.nativeDesc">活动将于{{ startTime }}开始</div>
    </div>
    <div v-if="activityStatus == 2" :class="`${$style.pageWrapper}`" :style="{filter: 'grayscale(.5)'}">
      <img :class="$style.pageBack" :src="cdnLink + `/box_turntable/luckyBg1.jpeg`" />
      <div :class="$style.nativeDesc">
        活动已结束
        <p :style="{fontSize: '15px'}">活动礼包请在我的礼包中查看使用</p>
      </div>
    </div>
    <div v-if="activityStatus == 1" :class="`${$style.pageWrapper}`">
      <img :class="$style.pageBack" :src="cdnLink + `/box_turntable/luckyBg1.jpeg`" />
      <div :class="$style.pageContent">
        <div :class="`${$style.part} ${$style.playPart}`">
          <h2 :class="$style.placeTitle">在玩游戏会场</h2>
          <div v-if="playGames.length > 0" :class="$style.gameList">
            <div
              v-for="game in playGames"
              :key="game.gameId"
              :class="$style.gameBox"
              @click="onSkipDetail({...game, isMore: false})"
            >
              <img :src="game.logo" alt="游戏图片" :class="$style.gameImg" />
              <div :class="$style.gameSection">
                <div :class="$style.gameTitle">{{ game.appName }}</div>
                <!-- <div :class="$style.gameDesc">{{ game.giftValue }}元礼包</div> -->
              </div>
            </div>
          </div>
          <div v-else :class="$style.empty">
            <p>暂无在玩游戏～</p>
            <p>请查看下方更多游戏会场，</p>
            <p>选择自己喜欢的游戏下载参与活动吧！</p>
          </div>
        </div>
        <div :class="`${$style.part} ${$style.morePart}`">
          <h2 :class="$style.placeTitle">更多游戏会场</h2>
          <div v-if="moreGames.length > 0" :class="$style.gameList">
            <div
              v-for="game in moreGames"
              :key="game.gameId"
              :class="$style.gameBox"
              @click="onSkipDetail({...game,isMore: true})"
            >
              <img :src="game.logo" alt="游戏图片" :class="$style.gameImg" />
              <div :class="$style.gameSection">
                <div :class="$style.gameTitle">{{ game.appName }}</div>
                <!-- <div :class="$style.gameDesc">{{ game.giftValue }}元礼包</div> -->
              </div>
            </div>
          </div>
          <div v-else :class="$style.empty">
            <p>暂无更多游戏～</p>
          </div>
        </div>
      </div>
      <!-- 弹窗 -->
      <div :class="$style.dialog" v-if="dialogVisible">
        <header>
          <span>不满足活动条件</span>
          <img
            :src="`${CDN_URL}/packet/close.png`"
            alt=""
            :class="$style.close"
            @click="dialogVisible = false"
          />
        </header>
        <main>
          <div>
            <p style="text-align: center">
              账号没有游戏记录，请下载并用此账号进入游戏后返回会场进入活动
            </p>
          </div>
          <div :class="$style.btnGroup">
            <button @click="onHandleGame" :class="$style.sureBtn">
              下载游戏
            </button>
          </div>
        </main>
      </div>
      <div :class="$style.mask" v-if="dialogVisible"></div>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import { CDN_URL_1,CDN_URL } from "@/config";
import {
  onGoBack,
  setPageTitle,
  getUserInfo,
  toLogin,
  signInEventTrack,
  jumpToNative
} from "@/bridge/AppJsBridge";
import { burnPoint } from '@/apis/heziShare'
import { 
  getPlaceListApi,
  sendPoint, 
} from "@/apis/wxActivity";
import { PullRefresh } from "vant";
import { ACTIVITY_NAME } from "./config";

export default {
  name: "",
  components: {
    PullRefresh,
  },
  data() {
    return {
      cdnLink: CDN_URL_1,
      pageTitle: ACTIVITY_NAME,
      userInfo: "",
      isLoading: false,
      moreGames: [],
      playGames: [],
      dialogVisible: false,
      CDN_URL:CDN_URL,
      gameInfo: null,
      deviceInfo:null,
      activityStatus: 1,
      startTime:'',
    };
  },
  computed: {
    compActivityId () {
      return this.$route.query ? this.$route.query.id : ''
    }
  },

  created() {
    // 页面初始化
    inithandler();
    this.initPageData();
  },
  activated() {
    setPageTitle(this.pageTitle);
    this.getActPlaceData();
  },
  mounted() {},
  methods: {
    // 下拉刷新
    async onRefresh() {
      this.eventTrack({
        event: "turntable_h5_summary_page",
        event_field: JSON.stringify({
          activity_name: ACTIVITY_NAME,
          activity_id: this.compActivityId,
        }),
      });
      await this.getActPlaceData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    // 数据上报
    eventTrack(data) {
      burnPoint({
        ...this.deviceInfo,
        ...data,
      }).catch((err) => console.log(err));
    },
    // 获取缓存等携带的用户信息数据
    async initPageData() {
      setPageTitle(this.pageTitle);
      
      // 获取token
      getUserInfo((userInfo) => {
        this.userInfo = JSON.parse(userInfo);
        if (this.userInfo.token) {
          localStorage.setItem("token", this.userInfo.token);
        } else {
          toLogin("/loginKey/LoginByKeyPhoneActivity");
          return;
        }
        this.getActPlaceData();
      });
      // 获取设备信息
      signInEventTrack(data => {
        this.deviceInfo = JSON.parse(data);
        localStorage.setItem("deviceInfo", data);
        this.eventTrack({
          event: "turntable_h5_summary_page",
          event_field: JSON.stringify({
            activity_name: ACTIVITY_NAME,
            activity_id: this.compActivityId,
          }),
        });
      });
    },
    // 获取会场信息
    getActPlaceData() {
      getPlaceListApi({ activityId: this.compActivityId }).then((res) => {
        const { data } = res;
        this.playGames = data.playGames;
        this.moreGames = data.moreGames;
        this.activityStatus = data.activityStatus;
        this.startTime = data.startTime;
      })
    },

    // 跳转游戏活动页面
    async onSkipDetail(data) {
      if (!this.deviceInfo) {
        this.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"));
      }
      const { activityGameId, isMore, gameId, appName } = data;
      this.gameInfo = data;
      this.eventTrack({
        event: "turntable_h5_game_branch",
        event_field: JSON.stringify({
          is_play: isMore ? 2 : 1,
          activity_id: this.compActivityId,
          activity_name: appName,
          activity_game_id: activityGameId
        }),
        appkey: gameId,
        appName: appName,
      });
      if (isMore) {
        this.dialogVisible = true;
        return;
      }
      this.$router.push({
        name: `box.wxLuckyTurntable`,
        query: {
          id: this.compActivityId,
        },
        params: {
          wheelActivityId: activityGameId,
        },
      });
    },

    // 跳转游戏
    onHandleGame(){
      const { appName, activityGameId, gameId } = this.gameInfo || {}
      this.eventTrack({
        event: "turntable_h5_chance_pop_download",
        event_field: JSON.stringify({
          activity_id: this.compActivityId,
          activity_name: appName,
          activity_game_id: activityGameId
        }),
        appkey: gameId,
        appName: appName,
      });
      this.dialogVisible = false;
      const data = {
        routePath: "/main/game/GameDetailActivity",
        extraParams: gameId,
        fromPageType: 19,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 关闭页面
    closePage() {
      onGoBack();
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.pageWrapper {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  margin: auto;
  overflow: auto;
  background-size: cover;
  background: #fc4b44;
  position: relative;

  .nativeDesc {
    width: 100%;
    height: 39.24px;
    line-height: 39.24px;
    position: absolute;
    top: calc(50% - 30px);
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    font-size: 18.75px;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.1)
    );
    letter-spacing: 1px;
  }
  .pageBack {
    width: 100%;
    height: 100vh;
    z-index: 1;
  }
  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
    .download {
      top: 0px;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }

  .pageContent{
    margin: 0 auto;
    top: 39.5%;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 2;
  }
  .part {
    width: 88.9%;
    margin: 0 auto 20px;
    padding: 11.34px 10.36px 10.65px;
    background: linear-gradient(180deg, #fde6d6 0%, #ffd6b5 100%);
    border-radius: 4px;
    box-shadow: 1px 1px 3px 1px rgba(185, 31, 8, 0.64),
      1px 1px 0px 1px rgba(255, 255, 255, 0.75) inset,
      0px 0px 0.61px 0px rgba(255, 77, 77, 0.83) inset;
    .placeTitle {
      font-size: 18px;
      font-weight: 700;
      text-align: left;
      line-height: 20px;
      margin-bottom: 10px;
    }
    .empty {
      color: #fc5f5e;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      > p {
        line-height: 24px;
      }
    }
    .gameList {
      display: flex;
      flex-wrap: wrap;
    }
    .gameBox {
      width: 47%;
      display: flex;
      justify-content: left;
      align-items: center;
      margin-bottom: 6px;
      margin-left: 9px;
      .gameImg {
        width: 45px;
        height: 45px;
        margin-right: 5px;
      }
      .gameTitle {
        font-size: 14px;
        font-weight: 700;
        text-align: left;
        color: #666666;
        line-height: 14px;
      }
      .gameDesc {
        font-size: 12px;
        font-weight: 500;
        text-align: left;
        color: #ff7a2a;
        line-height: 12px;
        margin-top: 9px;
      }
    }
  }
  .playPart {
    margin-top: 2px;
    .placeTitle {
      color: #fc5f5e;
    }
  }
  .morePart {
    margin-top: 10px;
    .placeTitle {
      color: #ff7a2a;
    }
  }

  .dialog {
    width: 306px;
    max-height: 240px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background-color: #ffffff;
    z-index: 100;
    border-radius: 4px;
    overflow: hidden;
    > header {
      display: flex;
      background: linear-gradient(90deg, #ff782c 0%, #ffb503 100%);
      font-size: 19px;
      color: #ffffff;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      height: 37px;
      .close {
        position: absolute;
        top: 8px;
        right: 10px;
        width: 16px;
        height: 16px;
      }
    }
    > main {
      text-align: center;
      padding-top: 30px;
      .bt {
        font-size: 18px;
        font-weight: 700;
        color: #ff612c;
        margin-bottom: 30px;
        text-align: center;
      }
      p {
        width: 230px;
        margin: auto;
        text-align: left;
        font-size: 16px;
        line-height: 24px;
        > span {
          color: #ff612c;
        }
      }
      .hint {
        font-size: 13px;
        color: #666666;
      }
    }
    .btnGroup {
      position: absolute;
      bottom: 20px;
      display: flex;
      justify-content: center;
      width: 80%;
      left: 0;
      right: 0;
      margin: auto;
      > button {
        border: none;
        outline: none;
        width: 105px;
        height: 35px;
        font-size: 13px;
        border-radius: 35px;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        &:active {
          opacity: 0.8;
        }
      }
      .cancelBtn {
        background: #fff2f2;
        color: #fc5f5e;
      }
      .sureBtn {
        background: #fd383c;
        color: #ffffff;
      }
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;
  }
}
</style>
